import TextField from '@jobseeker/lotus/elements/Input';
import {
  Box,
  Chip,
  InputAdornment,
  Typography,
  styled,
  useTheme,
} from '@mui/material';
import Slide from '@mui/material/Slide';
import MuiTab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import {TransitionProps} from '@mui/material/transitions';
import {Key, forwardRef, useMemo, useState, useEffect} from 'react';
import SelectList from './selectList';
import NextImage from '@jobseeker/lotus/components/Image';

import {FilterChips, calculateAppliedFilters} from '@jobseeker/lotus/components';
import {
  categories,
  categoryOptions,
  experienceOptionsHirist,
  experiences,
  HIRIST_FUNCTIONAL_AREAS,
  locations,
  methodOptions,
  postings,
  postingsHirist,
  sortBy,
} from '@jobseeker/lotus/components/JobSearchBar/data';
import {ButtonV2, VersionVariants} from '@jobseeker/lotus/elements';
import BottomSheet from '@jobseeker/lotus/elements/BottomSheet';
import {CrossOutlined, Filter, FilterMob, SearchIcon} from '@jobseeker/lotus/icons';
const optionsMap: any = {
  experiance: experiences,
  posting: postings,
  location: locations,
  category: categories,
  functionalArea: HIRIST_FUNCTIONAL_AREAS,
};

const Image = styled(NextImage)(() => ({}));

const Tab = styled(MuiTab)(props => ({
  fontWeight: 400,
  borderBottom: `1px solid ${props.theme.palette.border.main}`,
  '&.Mui-selected': {
    color: '#000',
    fontWeight: 500,
  },
}));
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
const TabPanelBox = styled(Box)(props => ({
  borderColor: props.theme.palette.border.main,
}));

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface TabPanelProps {
  children?: React.ReactNode;
  index?: number;
  value: string;
  selectedValue: string;
  // offsetHeight?: number;
}

const ChipPanel = ({items, onDelete}: any) => {
  return (
    <Box
      sx={{
        // minHeight: 'fit-content',
        transition: 'all ease 0.3',
        display: 'flex',
        // flexWrap: 'wrap',
        width: '100%',
        overflow: 'scroll',
        scrollbarWidth: 'none',
        gap: 1,
      }}
    >
      {/* {JSON.stringify(appliedFilters)} */}
      {items.map((f: {label: string}, i: Key) => (
        <Chip
          key={`filterchip-dialog-${i}`}
          label={f.label}
          // variant="outlined"
          onClick={() => onDelete(f)}
          onDelete={() => onDelete(f)}
        />
      ))}
    </Box>
  );
};

function TabPanel(props: TabPanelProps) {
  const {children, value, index, ...other} = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== other.selectedValue}
      id={`filter-tabpanel-${index || value}`}
      aria-labelledby={`filter-tab-${index || value}`}
      sx={{
        overflow: 'scroll',
        scrollbarWidth: 'none',
        width: '100%',
        ml: '150px',
        // minHeight: height,
        // height,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}

const FilterModal = ({
  isFilter,
  showSortBy,
  formValue = {},
  onChange,
  showCategory = false,
  showIndustry,
  showPosting,
  showFunctionalArea,
  ...props
}: any) => {
  const isFilterBar = isFilter;
  const [value, setValue] = useState(
    showSortBy && isAppIimjobs
      ? 'sort'
      : props.courses || props.company
      ? 'category'
      : 'experience'
  );
  // const [formValue, setFormValue] = useState<any>({sort: [119]});

  const setFormValue = (value: any) => {
    if (onChange) {
      onChange(value);
    }
  };

  const theme = useTheme();
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    console.log({newValue});
    setValue(newValue);
  };
  const locationMap = (value: any) => {
    let locationString = '';

    value?.forEach((location: any) => {
      locations?.forEach(locObj => {
        if (location === locObj?.value) {
          if (locationString) {
            locationString = `${locationString}_${locObj?.label}`;
          } else {
            locationString = locObj?.label;
          }
        }
      });
    });

    return locationString;
  };
  const submitFilter = () => {
    const modifiedData: any = {};
    if (Array.isArray(formValue?.loc) && formValue?.loc.length > 0) {
      modifiedData.locationLabels = locationMap(formValue?.loc);
    }
    if (Array.isArray(formValue?.sort) && formValue?.sort.length > 0) {
      modifiedData.sort = formValue?.sort?.map(
        (s: string | number) =>
          sortBy.find(sb => sb.value == s)?.label.toLowerCase()
      );
    }
    props.onFilter && props.onFilter({...formValue, ...modifiedData});
    props.onDismiss();
  };
  const [searchTerm, setSearchTerm] = useState('');

  const appliedFilters = useMemo(() => {
    let industryOptions: any = [];
    props?.industryOptions?.forEach((option: any) => {
      if (option.options)
        industryOptions = industryOptions.concat(option.options);
    });
    return calculateAppliedFilters(formValue, {
      industry: industryOptions,
    })?.filter(
      (item: {label: string}) =>
        ![
          'Date',
          'Relevance',
          'All Categories',
          'All Postings',
          'All Exp. Level',
          'keyword',
          'query',
        ].includes(item.label)
    );
  }, [formValue]);

  const deleteFilter = (filterValue: any) => {
    let filteredFormValue = formValue[filterValue.key].filter(
      (fv: any) => fv != filterValue.value
    );
    if (filterValue.selected) {
      filteredFormValue = filteredFormValue.filter(
        (fv: any) => !filterValue.selected.includes(fv)
      );
    }
    const newFormValue = {...formValue};
    newFormValue[filterValue.key] = filteredFormValue;
    setFormValue(newFormValue);
  };

  const clearFilter = () => {
    setFormValue({
      query: formValue.query ?? '',
      loc: [],
      category: [],
      experience: [],
      posting: [],
      sort: showSortBy ? ['date'] : [],
      industry: [],
      functionalArea: [],
    });
  };

  return (
    <BottomSheet
      {...props}
      title="Filter By"
      header={
        <Box p={2}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              cursor: 'default',
              alignItems: 'center',
              paddingBottom: '1px',
            }}
          >
            <Typography variant="subtitle2">Filter By</Typography>
            <Image
              src={CrossOutlined}
              alt={'Close Icon'}
              width={18}
              height={18}
              onClick={props.onDismiss}
              objectFit="cover"
              style={{cursor: 'pointer'}}
            />
          </Box>
        </Box>
      }
      footer={
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            background: '#fff',
            p: 2,
            borderTop: '1px solid',
            borderColor: 'border.main',
          }}
        >
          <ButtonV2
            variant="outlined"
            size="small"
            onClick={clearFilter}
            color="primary"
            sx={{
              width: '50%',
              mx: 2,
              fontSize: 14,
              borderColor: 'primary',
              borderRadius: isAppIimjobs ? '100px' : '6px',
            }}
          >
            Clear All
          </ButtonV2>
          {/* <Divider orientation="vertical" flexItem /> */}
          <ButtonV2
            size="small"
            variant="contained"
            onClick={submitFilter}
            sx={{
              width: '50%',
              mx: 2,
              background: isAppIimjobs ? '#000' : '#e9630c',
              fontSize: 14,
              borderRadius: isAppIimjobs ? '100px' : '6px',
            }}
          >
            Apply
          </ButtonV2>
        </Box>
      }
    >
      <Box position={'relative'}>
        {appliedFilters?.length &&
        !props.courses &&
        !props.company &&
        isAppIimjobs ? (
          <Box
            position={'fixed'}
            zIndex={2}
            top={55}
            p={2}
            sx={{
              borderBottom: '1px solid',
              borderTop: '1px solid',
              width: '100%',
              // borderColor: theme.palette.divider,
              borderColor: 'border.main',
              backgroundColor: '#ffffff',
              minHeight: '65px',
            }}
          >
            <FilterChips items={appliedFilters} onDelete={deleteFilter} />
          </Box>
        ) : (
          <></>
        )}

        <Box
          sx={{
            bgcolor: 'background.paper',
            display: 'flex',
            height: '100%',
            mt:
              appliedFilters?.length &&
              !props.courses &&
              !props.company &&
              isAppIimjobs
                ? '65px'
                : '0px',
          }}
        >
          <Tabs
            orientation="vertical"
            variant="standard"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs"
            TabIndicatorProps={{sx: {display: 'none'}}}
            sx={{
              height: '100%',
              minWidth: '130px',
              position: 'fixed',
              borderRight: '1px solid',
              borderColor: theme.palette.border.main,
              background: '#fff',
            }}
          >
            {showSortBy && isAppIimjobs && (
              <Tab
                disableRipple
                value={'sort'}
                label={`Sort By (${formValue.sort?.length ?? 0})`}
              />
            )}
            {props.courses || props.company ? (
              <>
                {' '}
                <Tab
                  disableRipple
                  value={'category'}
                  label={`Category`}
                  sx={{
                    opacity: value === 'category' ? 1 : 0.6,

                    alignItems: 'baseline',
                    color: value === 'category' ? '#E9630C' : 'inherit',
                  }}
                  onClick={e => {
                    handleChange(e, 'category');
                  }}
                />
                {props.courses ? (
                  <>
                    <Tab
                      disableRipple
                      value={'method'}
                      label={`Method`}
                      sx={{
                        opacity: value === 'method' ? 1 : 0.6,

                        alignItems: 'baseline',
                        color: value === 'method' ? '#E9630C' : 'inherit',
                      }}
                      onClick={e => {
                        handleChange(e, 'method');
                      }}
                    />
                    <Tab
                      disableRipple
                      value={'experience'}
                      label={`Experiance`}
                      sx={{
                        opacity: value === 'experience' ? 1 : 0.6,

                        alignItems: 'baseline',
                        color: value === 'experience' ? '#E9630C' : 'inherit',
                      }}
                      onClick={e => {
                        handleChange(e, 'experience');
                      }}
                    />
                  </>
                ) : (
                  <>
                    <Tab
                      disableRipple
                      value={'location'}
                      label={`Location`}
                      sx={{
                        opacity: value === 'location' ? 1 : 0.6,

                        alignItems: 'baseline',
                        color: value === 'location' ? '#E9630C' : 'inherit',
                      }}
                      onClick={e => {
                        handleChange(e, 'location');
                      }}
                    />
                  </>
                )}
              </>
            ) : (
              <>
                <Tab
                  disableRipple
                  value={'experience'}
                  label={`Experience (${formValue.experience?.length ?? 0})`}
                  sx={{
                    opacity: value === 'experience' ? 1 : 0.6,
                    alignItems: 'baseline',
                    color:
                      value === 'experience' && !isAppIimjobs
                        ? '#E9630C'
                        : 'inherit',
                    fontWeight:
                      value !== 'experience' || !isAppIimjobs ? 400 : 500,
                  }}
                  onClick={e => {
                    handleChange(e, 'experience');
                  }}
                />
                <Tab
                  disableRipple
                  value={'location'}
                  label={`Location (${formValue.loc?.length ?? 0})`}
                  sx={{
                    opacity: value === 'location' ? 1 : 0.6,

                    alignItems: 'baseline',
                    color:
                      value === 'location' && !isAppIimjobs
                        ? '#E9630C'
                        : 'inherit',
                    fontWeight:
                      value !== 'location' || !isAppIimjobs ? 400 : 500,
                  }}
                  onClick={e => {
                    handleChange(e, 'location');
                  }}
                />
                {!isAppIimjobs && showFunctionalArea && (
                  <Tab
                    disableRipple
                    value={'functionalArea'}
                    label={`Functional Area (${
                      formValue.functionalArea?.length ?? 0
                    })`}
                    sx={{
                      opacity: value === 'functionalArea' ? 1 : 0.6,
                      alignItems: 'baseline',
                      color:
                        value === 'functionalArea' && !isAppIimjobs
                          ? '#E9630C'
                          : 'inherit',
                      fontWeight:
                        value !== 'functionalArea' || !isAppIimjobs ? 400 : 500,
                    }}
                    onClick={e => {
                      handleChange(e, 'functionalArea');
                    }}
                  />
                )}
              </>
            )}
            {!showSortBy &&
              !showCategory &&
              isAppIimjobs &&
              !props.courses &&
              !props.company && (
                <Tab
                  disableRipple
                  value={'industry'}
                  label={`Industry (${formValue.industry?.length ?? 0})`}
                  sx={{alignItems: 'baseline'}}
                />
              )}
            {showPosting && (
              <Tab
                disableRipple
                value={'posting'}
                label={`Posting (${
                  formValue.posting?.filter((i: number) => i).length ?? 0
                })`}
                sx={{
                  alignItems: 'baseline',
                  opacity: value === 'posting' ? 1 : 0.6,
                  color:
                    value === 'posting' && !isAppIimjobs
                      ? '#E9630C !important'
                      : 'inherit',
                  fontWeight:
                    value !== 'posting' || !isAppIimjobs
                      ? '400 !important'
                      : 500,
                }}
              />
            )}
            {showCategory && (
              <Tab
                disableRipple
                value={'category'}
                label={`Category (${formValue.category?.length ?? 0})`}
                sx={{alignItems: 'baseline'}}
              />
            )}
          </Tabs>
          {props.courses || props.company ? (
            <>
              <TabPanel value={'category'} selectedValue={value}>
                <TabPanelBox pt={0.75}>
                  <SelectList
                    onChange={(e: any, value: any) =>
                      setFormValue({...formValue, category: value[0]})
                    }
                    options={categoryOptions}
                    selected={[formValue.category]}
                  />
                </TabPanelBox>
              </TabPanel>
              <TabPanel value={'experience'} selectedValue={value}>
                <TabPanelBox pt={0.75}>
                  <SelectList
                    onChange={(e: any, value: any) => {
                      setFormValue({...formValue, experience: value[0]});
                    }}
                    options={experienceOptionsHirist}
                    selected={[formValue.experience]}
                  />
                </TabPanelBox>
              </TabPanel>
              <TabPanel value={'method'} selectedValue={value}>
                <TabPanelBox pt={0.75}>
                  <SelectList
                    onChange={(e: any, value: any) =>
                      setFormValue({...formValue, method: value[0]})
                    }
                    options={methodOptions}
                    selected={[formValue.method]}
                  />
                </TabPanelBox>
              </TabPanel>
              {props.company && (
                <TabPanel value={'location'} selectedValue={value}>
                  <TabPanelBox pt={0.75}>
                    <Box display="flex" flexDirection="column" gap={1}>
                      <TextField
                        // size="small"
                        // Autofocus on textfield
                        autoFocus
                        placeholder={'Search Location...'}
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Image
                                src={SearchIcon}
                                alt="search"
                                width={12}
                                height={12}
                              />
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          width: '90%',
                          ml: '5%',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                          },

                          '& .MuiOutlinedInput-notchedOutline': {
                            border: !isAppIimjobs
                              ? '1px solid #7E7E7E33 !important'
                              : 'none', // Always visible border
                          },

                          '.MuiInputBase-input': {
                            border: 'unset !important',
                            fontSize: !isAppIimjobs
                              ? '14px !important'
                              : '10px !important',
                            paddingLeft: 0,
                            backgroundColor: !isAppIimjobs
                              ? '#f3f3f3'
                              : 'transparent',
                            paddingTop: !isAppIimjobs
                              ? '8px !important'
                              : '0px',
                            paddingBottom: !isAppIimjobs
                              ? '8px !important'
                              : '0px',
                          },
                          '.MuiInputBase-root': {
                            borderRadius: !isAppIimjobs
                              ? '4px !important'
                              : '100px',
                            backgroundColor: !isAppIimjobs
                              ? '#f3f3f3'
                              : 'transparent',
                            paddingTop: !isAppIimjobs
                              ? '-8px !important'
                              : '8px',
                            paddingBottom: !isAppIimjobs
                              ? '-8px !important'
                              : '8px',
                            border: !isAppIimjobs
                              ? 'none'
                              : '1px solid #7E7E7E33',
                          },
                        }}
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target?.value)}
                        onKeyDown={e => {
                          if (e.key !== 'Escape') {
                            // Prevents autoselecting item while typing (default Select behaviour)
                            e.stopPropagation();
                          }
                        }}
                        variant={VersionVariants.VERSION_TWO}
                      />
                      <SelectList
                        onChange={(e: any, value: any) =>
                          setFormValue({...formValue, loc: value})
                        }
                        multiSelect
                        options={locations.filter(loc =>
                          loc.label
                            .toLowerCase()
                            .includes(searchTerm.toLowerCase())
                        )}
                        selected={formValue.loc}
                      />
                    </Box>
                  </TabPanelBox>
                </TabPanel>
              )}
            </>
          ) : (
            showSortBy && (
              <TabPanel value={'sort'} selectedValue={value}>
                <TabPanelBox pt={0.75}>
                  <SelectList
                    onChange={(e: any, value: any) =>
                      setFormValue({...formValue, sort: value})
                    }
                    options={sortBy}
                    selected={formValue.sort}
                  />
                </TabPanelBox>
              </TabPanel>
            )
          )}
          {!props.courses && !props.company && (
            <>
              <TabPanel value={'experience'} selectedValue={value}>
                <TabPanelBox pt={0.75}>
                  <SelectList
                    onChange={(e: any, value: any) =>
                      setFormValue({...formValue, experience: value})
                    }
                    options={
                      isAppIimjobs ? experiences : experienceOptionsHirist
                    }
                    selected={formValue.experience}
                  />
                </TabPanelBox>
              </TabPanel>
              {isAppIimjobs ? (
                <TabPanel value={'location'} selectedValue={value}>
                  <TabPanelBox pt={0.75}>
                    <SelectList
                      onChange={(e: any, value: any) =>
                        setFormValue({...formValue, loc: value})
                      }
                      multiSelect
                      options={locations}
                      selected={formValue.loc}
                    />
                  </TabPanelBox>
                </TabPanel>
              ) : (
                <TabPanel value={'location'} selectedValue={value}>
                  <TabPanelBox pt={0.75}>
                    <Box display="flex" flexDirection="column" gap={1}>
                      <TextField
                        // size="small"
                        // Autofocus on textfield
                        autoFocus
                        placeholder={'Search Location...'}
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Image
                                src={SearchIcon}
                                alt="search"
                                width={12}
                                height={12}
                              />
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          width: '90%',
                          ml: '5%',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                          },

                          '& .MuiOutlinedInput-notchedOutline': {
                            border: !isAppIimjobs
                              ? '1px solid #7E7E7E33 !important'
                              : 'none', // Always visible border
                          },

                          '.MuiInputBase-input': {
                            border: 'unset !important',
                            fontSize: !isAppIimjobs
                              ? '14px !important'
                              : '10px !important',
                            paddingLeft: 0,
                            backgroundColor: !isAppIimjobs
                              ? '#f3f3f3'
                              : 'transparent',
                            paddingTop: !isAppIimjobs
                              ? '8px !important'
                              : '0px',
                            paddingBottom: !isAppIimjobs
                              ? '8px !important'
                              : '0px',
                          },
                          '.MuiInputBase-root': {
                            borderRadius: !isAppIimjobs
                              ? '4px !important'
                              : '100px',
                            backgroundColor: !isAppIimjobs
                              ? '#f3f3f3'
                              : 'transparent',
                            paddingTop: !isAppIimjobs
                              ? '-8px !important'
                              : '8px',
                            paddingBottom: !isAppIimjobs
                              ? '-8px !important'
                              : '8px',
                            border: !isAppIimjobs
                              ? 'none'
                              : '1px solid #7E7E7E33',
                          },
                        }}
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target?.value)}
                        onKeyDown={e => {
                          if (e.key !== 'Escape') {
                            // Prevents autoselecting item while typing (default Select behaviour)
                            e.stopPropagation();
                          }
                        }}
                        variant={VersionVariants.VERSION_TWO}
                      />
                      <SelectList
                        onChange={(e: any, value: any) =>
                          setFormValue({...formValue, loc: value})
                        }
                        multiSelect
                        options={locations.filter(loc =>
                          loc.label
                            .toLowerCase()
                            .includes(searchTerm.toLowerCase())
                        )}
                        selected={formValue.loc}
                      />
                    </Box>
                  </TabPanelBox>
                </TabPanel>
              )}
            </>
          )}
          {/* Functional Area TabPanel - Only for Hirist */}
          {!isAppIimjobs && (
            <TabPanel value={'functionalArea'} selectedValue={value}>
              <TabPanelBox pt={0.75}>
                <SelectList
                  onChange={(e: any, value: any) =>
                    setFormValue({...formValue, functionalArea: value})
                  }
                  options={HIRIST_FUNCTIONAL_AREAS}
                  selected={formValue.functionalArea}
                />
              </TabPanelBox>
            </TabPanel>
          )}
          {showCategory && (
            <TabPanel value={'category'} selectedValue={value}>
              <TabPanelBox pt={0.75}>
                <SelectList
                  onChange={(e: any, value: any) =>
                    setFormValue({...formValue, category: value})
                  }
                  options={isAppIimjobs ? categories : categoryOptions}
                  selected={formValue.category}
                />
              </TabPanelBox>
            </TabPanel>
          )}
          {showIndustry && (
            <TabPanel value={'industry'} selectedValue={value}>
              <TabPanelBox pt={0.75}>
                {props.industryOptions?.map((option: any) => (
                  <>
                    <Typography pl={2} pt={2} color="#7e7e7e" fontSize={12}>
                      {option.label}
                    </Typography>
                    <SelectList
                      onChange={(e: any, value: any) =>
                        setFormValue({...formValue, industry: value})
                      }
                      multiSelect
                      options={option.options || []}
                      selected={formValue.industry}
                    />
                  </>
                ))}
              </TabPanelBox>
            </TabPanel>
          )}
          {showPosting && (
            <TabPanel value={'posting'} selectedValue={value}>
              <TabPanelBox pt={0.75}>
                <SelectList
                  onChange={(e: any, value: any) =>
                    setFormValue({...formValue, posting: value})
                  }
                  options={isAppIimjobs ? postings : postingsHirist}
                  selected={formValue.posting}
                />
              </TabPanelBox>
            </TabPanel>
          )}
        </Box>
      </Box>
    </BottomSheet>
  );
};

const FilterDialog = (props: any) => {
  const theme = useTheme();
  const [dialogOpen, setDialogOpen] = useState(props.open ?? false);

  const handleClose = () => {
    setDialogOpen(false);
    if (props.handleClose) {
      props.handleClose();
    }
  };

  const handleOpen = () => {
    setDialogOpen(true);
    if (props.handleOpen) {
      props.handleOpen();
    }
  };

  return (
    <>
      <FilterModal open={dialogOpen} onDismiss={handleClose} {...props} />
      <Box
        onClick={handleOpen}
        sx={
          isAppIimjobs
            ? {
                p: isAppIimjobs ? {xxs: '8.65px', xs: '11px'} : 0,
                background: '#fff',
                lineHeight: 0,
                // boxShadow: theme.shadows[2],
                filter: 'drop-shadow(0px 6.5px 6px rgba(41, 41, 41, 0.02))',
                borderRadius: '100%',
                gap: '8px',
                border: isAppIimjobs
                  ? `1px solid ${theme.palette.gray.dark}`
                  : 'none',
                cursor: 'pointer',
                width: 'fit-content',
                backgroundColor: '#fff',
              }
            : {}
        }
      >
        <Image
          src={isAppIimjobs ? Filter : FilterMob}
          alt={'Filter'}
          // width="16"
          // height={'16'}
          sx={{
            width: isAppIimjobs ? {xxs: '12.8px', xs: '16px'} : '60px',
            height: isAppIimjobs ? {xxs: '12.8px', xs: '16px'} : '60px',
          }}
          objectFit="cover"
          quality={50}
        />
      </Box>
    </>
  );
};

export default FilterDialog;
